// @ts-nocheck
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
import * as Types from "../../__generated__/schema.graphql.types";

const defaultOptions = {} as const;
export type PayrollCheckComponentsQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  bankAccountUrl?: Types.Scalars["Boolean"]["input"];
  businessDetailsUrl?: Types.Scalars["Boolean"]["input"];
  employeeSetupUrl?: Types.Scalars["Boolean"]["input"];
  filingAuthorizationUrl?: Types.Scalars["Boolean"]["input"];
  payHistoryUrl?: Types.Scalars["Boolean"]["input"];
  taxSetupUrl?: Types.Scalars["Boolean"]["input"];
  teamSetupUrl?: Types.Scalars["Boolean"]["input"];
  runPayrollUrl?: Types.Scalars["Boolean"]["input"];
  verificationDocumentsUrl?: Types.Scalars["Boolean"]["input"];
}>;

export type PayrollCheckComponentsQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      id: string;
      bankAccountUrl?: string | null;
      businessDetailsUrl?: string | null;
      employeeSetupUrl?: string | null;
      filingAuthorizationUrl?: string | null;
      payHistoryUrl?: string | null;
      taxSetupUrl?: string | null;
      teamSetupUrl?: string | null;
      runPayrollUrl?: string | null;
      verificationDocumentsUrl?: string | null;
    } | null;
  } | null;
};

export type PayrollOnboardQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  userMedspaId: Types.Scalars["bigint"]["input"];
}>;

export type PayrollOnboardQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      workerCount?: number | null;
      bankAccountStatus?: Types.BankAccountStatus | null;
      latestFeinVerificationStatus?: Types.FeinVerificationStatus | null;
      isBusinessDetailsCompleted: boolean;
      isPayHistoryCompleted: boolean;
      isFirstPayroll?: boolean | null;
      filingAuthorizationBlockingCount?: number | null;
      filingAuthorizationNeedsAttentionCount?: number | null;
      teamSetupWorkersBlockingCount?: number | null;
      teamSetupWorkersNeedsAttentionCount?: number | null;
      teamSetupCurrentUser?: boolean | null;
      companyDefinedEmployeeSetupBlockingCount?: number | null;
      companyDefinedEmployeeSetupNeedsAttentionCount?: number | null;
      companyDefinedEmployeeSetupCurrentUser?: boolean | null;
      taxSetupBlockingCount?: number | null;
      taxSetupNeedsAttentionCount?: number | null;
      taxSetupJurisdictionsMissingTaxId?: Array<string | null> | null;
      businessType?: string | null;
      industryType?: string | null;
      legalName?: string | null;
      phone?: string | null;
      email?: string | null;
      address?: string | null;
      implementationStatus: Types.PayrollCompanyImplementationStatusChoices;
      isReadyForImplementation?: boolean | null;
      onboardStatus?: Types.OnboardStatus | null;
      documentRequests?: Array<{
        __typename?: "DocumentRequestType";
        id?: number | null;
        title?: string | null;
        status?: Types.DocumentRequestStatus | null;
        errors?: Array<string | null> | null;
      } | null> | null;
    } | null;
  } | null;
  userMedspaByPk?: {
    __typename?: "userMedspa";
    user: { __typename?: "user"; fullName?: string | null };
    payrollSignatory?: {
      __typename?: "PayrollSignatory";
      title: string;
    } | null;
  } | null;
};

export type PayrollViewInfoQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type PayrollViewInfoQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    isCurrentUserRegisteredEmployee?: boolean | null;
    isCurrentUserRegisteredContractor?: boolean | null;
    isCurrentUserOnboarded?: boolean | null;
  } | null;
};

export type RunPayrollReadyQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type RunPayrollReadyQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    company?: {
      __typename?: "CompanyType";
      runPayrollReady?: boolean | null;
    } | null;
  } | null;
};

export type PayrollPreliminaryInfoQueryVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type PayrollPreliminaryInfoQuery = {
  __typename?: "query_root";
  payroll?: {
    __typename?: "PayrollType";
    isCurrentUserRegisteredInCheck?: boolean | null;
    isCompanyRegisteredInCheck?: boolean | null;
  } | null;
};

export type MarkBusinessDetailsCompletedMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type MarkBusinessDetailsCompletedMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    markBusinessDetailsCompleted?: {
      __typename?: "MarkBusinessDetailsCompleted";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type MarkPayHistoryCompletedMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type MarkPayHistoryCompletedMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    markPayHistoryCompleted?: {
      __typename?: "MarkPayHistoryCompleted";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type SendOnboardRemindersToWorkersMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type SendOnboardRemindersToWorkersMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    sendOnboardRemindersToWorkers?: {
      __typename?: "SendOnboardRemindersToWorkers";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type StartImplementationMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
}>;

export type StartImplementationMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    startImplementation?: {
      __typename?: "StartImplementation";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export type CreateOrUpdateSignatoryMutationVariables = Types.Exact<{
  medspaId: Types.Scalars["String"]["input"];
  title: Types.Scalars["String"]["input"];
}>;

export type CreateOrUpdateSignatoryMutation = {
  __typename?: "mutation_root";
  payroll?: {
    __typename?: "PayrollMutations";
    createOrUpdateSignatory?: {
      __typename?: "CreateOrUpdateSignatory";
      ok: boolean;
      message?: string | null;
    } | null;
  } | null;
};

export const PayrollCheckComponentsDocument = gql`
  query PayrollCheckComponents(
    $medspaId: String!
    $bankAccountUrl: Boolean! = false
    $businessDetailsUrl: Boolean! = false
    $employeeSetupUrl: Boolean! = false
    $filingAuthorizationUrl: Boolean! = false
    $payHistoryUrl: Boolean! = false
    $taxSetupUrl: Boolean! = false
    $teamSetupUrl: Boolean! = false
    $runPayrollUrl: Boolean! = false
    $verificationDocumentsUrl: Boolean! = false
  ) {
    payroll {
      company(medspaId: $medspaId) {
        id
        bankAccountUrl @include(if: $bankAccountUrl)
        businessDetailsUrl @include(if: $businessDetailsUrl)
        employeeSetupUrl @include(if: $employeeSetupUrl)
        filingAuthorizationUrl @include(if: $filingAuthorizationUrl)
        payHistoryUrl @include(if: $payHistoryUrl)
        taxSetupUrl @include(if: $taxSetupUrl)
        teamSetupUrl @include(if: $teamSetupUrl)
        runPayrollUrl @include(if: $runPayrollUrl)
        verificationDocumentsUrl @include(if: $verificationDocumentsUrl)
      }
    }
  }
`;

/**
 * __usePayrollCheckComponentsQuery__
 *
 * To run a query within a React component, call `usePayrollCheckComponentsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollCheckComponentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollCheckComponentsQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      bankAccountUrl: // value for 'bankAccountUrl'
 *      businessDetailsUrl: // value for 'businessDetailsUrl'
 *      employeeSetupUrl: // value for 'employeeSetupUrl'
 *      filingAuthorizationUrl: // value for 'filingAuthorizationUrl'
 *      payHistoryUrl: // value for 'payHistoryUrl'
 *      taxSetupUrl: // value for 'taxSetupUrl'
 *      teamSetupUrl: // value for 'teamSetupUrl'
 *      runPayrollUrl: // value for 'runPayrollUrl'
 *      verificationDocumentsUrl: // value for 'verificationDocumentsUrl'
 *   },
 * });
 */
export function usePayrollCheckComponentsQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollCheckComponentsQuery,
    PayrollCheckComponentsQueryVariables
  > &
    (
      | { variables: PayrollCheckComponentsQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PayrollCheckComponentsQuery,
    PayrollCheckComponentsQueryVariables
  >(PayrollCheckComponentsDocument, options);
}
export function usePayrollCheckComponentsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollCheckComponentsQuery,
    PayrollCheckComponentsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollCheckComponentsQuery,
    PayrollCheckComponentsQueryVariables
  >(PayrollCheckComponentsDocument, options);
}
export function usePayrollCheckComponentsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollCheckComponentsQuery,
        PayrollCheckComponentsQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollCheckComponentsQuery,
    PayrollCheckComponentsQueryVariables
  >(PayrollCheckComponentsDocument, options);
}
export type PayrollCheckComponentsQueryHookResult = ReturnType<
  typeof usePayrollCheckComponentsQuery
>;
export type PayrollCheckComponentsLazyQueryHookResult = ReturnType<
  typeof usePayrollCheckComponentsLazyQuery
>;
export type PayrollCheckComponentsSuspenseQueryHookResult = ReturnType<
  typeof usePayrollCheckComponentsSuspenseQuery
>;
export type PayrollCheckComponentsQueryResult = Apollo.QueryResult<
  PayrollCheckComponentsQuery,
  PayrollCheckComponentsQueryVariables
>;
export const PayrollOnboardDocument = gql`
  query PayrollOnboard($medspaId: String!, $userMedspaId: bigint!) {
    payroll {
      company(medspaId: $medspaId) {
        workerCount
        bankAccountStatus
        latestFeinVerificationStatus
        isBusinessDetailsCompleted
        isPayHistoryCompleted
        isFirstPayroll
        filingAuthorizationBlockingCount
        filingAuthorizationNeedsAttentionCount
        teamSetupWorkersBlockingCount
        teamSetupWorkersNeedsAttentionCount
        teamSetupCurrentUser
        companyDefinedEmployeeSetupBlockingCount
        companyDefinedEmployeeSetupNeedsAttentionCount
        companyDefinedEmployeeSetupCurrentUser
        taxSetupBlockingCount
        taxSetupNeedsAttentionCount
        taxSetupJurisdictionsMissingTaxId
        businessType
        industryType
        legalName
        phone
        email
        address
        implementationStatus
        isReadyForImplementation
        onboardStatus
        documentRequests {
          id
          title
          status
          errors
        }
      }
    }
    userMedspaByPk(id: $userMedspaId) {
      user {
        fullName
      }
      payrollSignatory {
        title
      }
    }
  }
`;

/**
 * __usePayrollOnboardQuery__
 *
 * To run a query within a React component, call `usePayrollOnboardQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollOnboardQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollOnboardQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      userMedspaId: // value for 'userMedspaId'
 *   },
 * });
 */
export function usePayrollOnboardQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollOnboardQuery,
    PayrollOnboardQueryVariables
  > &
    (
      | { variables: PayrollOnboardQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PayrollOnboardQuery, PayrollOnboardQueryVariables>(
    PayrollOnboardDocument,
    options
  );
}
export function usePayrollOnboardLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollOnboardQuery,
    PayrollOnboardQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<PayrollOnboardQuery, PayrollOnboardQueryVariables>(
    PayrollOnboardDocument,
    options
  );
}
export function usePayrollOnboardSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollOnboardQuery,
        PayrollOnboardQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollOnboardQuery,
    PayrollOnboardQueryVariables
  >(PayrollOnboardDocument, options);
}
export type PayrollOnboardQueryHookResult = ReturnType<
  typeof usePayrollOnboardQuery
>;
export type PayrollOnboardLazyQueryHookResult = ReturnType<
  typeof usePayrollOnboardLazyQuery
>;
export type PayrollOnboardSuspenseQueryHookResult = ReturnType<
  typeof usePayrollOnboardSuspenseQuery
>;
export type PayrollOnboardQueryResult = Apollo.QueryResult<
  PayrollOnboardQuery,
  PayrollOnboardQueryVariables
>;
export const PayrollViewInfoDocument = gql`
  query PayrollViewInfo($medspaId: String!) {
    payroll {
      isCurrentUserRegisteredEmployee(medspaId: $medspaId)
      isCurrentUserRegisteredContractor(medspaId: $medspaId)
      isCurrentUserOnboarded(medspaId: $medspaId)
    }
  }
`;

/**
 * __usePayrollViewInfoQuery__
 *
 * To run a query within a React component, call `usePayrollViewInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollViewInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollViewInfoQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function usePayrollViewInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  > &
    (
      | { variables: PayrollViewInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<PayrollViewInfoQuery, PayrollViewInfoQueryVariables>(
    PayrollViewInfoDocument,
    options
  );
}
export function usePayrollViewInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  >(PayrollViewInfoDocument, options);
}
export function usePayrollViewInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollViewInfoQuery,
        PayrollViewInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollViewInfoQuery,
    PayrollViewInfoQueryVariables
  >(PayrollViewInfoDocument, options);
}
export type PayrollViewInfoQueryHookResult = ReturnType<
  typeof usePayrollViewInfoQuery
>;
export type PayrollViewInfoLazyQueryHookResult = ReturnType<
  typeof usePayrollViewInfoLazyQuery
>;
export type PayrollViewInfoSuspenseQueryHookResult = ReturnType<
  typeof usePayrollViewInfoSuspenseQuery
>;
export type PayrollViewInfoQueryResult = Apollo.QueryResult<
  PayrollViewInfoQuery,
  PayrollViewInfoQueryVariables
>;
export const RunPayrollReadyDocument = gql`
  query RunPayrollReady($medspaId: String!) {
    payroll {
      company(medspaId: $medspaId) {
        runPayrollReady
      }
    }
  }
`;

/**
 * __useRunPayrollReadyQuery__
 *
 * To run a query within a React component, call `useRunPayrollReadyQuery` and pass it any options that fit your needs.
 * When your component renders, `useRunPayrollReadyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRunPayrollReadyQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useRunPayrollReadyQuery(
  baseOptions: Apollo.QueryHookOptions<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  > &
    (
      | { variables: RunPayrollReadyQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<RunPayrollReadyQuery, RunPayrollReadyQueryVariables>(
    RunPayrollReadyDocument,
    options
  );
}
export function useRunPayrollReadyLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  >(RunPayrollReadyDocument, options);
}
export function useRunPayrollReadySuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        RunPayrollReadyQuery,
        RunPayrollReadyQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    RunPayrollReadyQuery,
    RunPayrollReadyQueryVariables
  >(RunPayrollReadyDocument, options);
}
export type RunPayrollReadyQueryHookResult = ReturnType<
  typeof useRunPayrollReadyQuery
>;
export type RunPayrollReadyLazyQueryHookResult = ReturnType<
  typeof useRunPayrollReadyLazyQuery
>;
export type RunPayrollReadySuspenseQueryHookResult = ReturnType<
  typeof useRunPayrollReadySuspenseQuery
>;
export type RunPayrollReadyQueryResult = Apollo.QueryResult<
  RunPayrollReadyQuery,
  RunPayrollReadyQueryVariables
>;
export const PayrollPreliminaryInfoDocument = gql`
  query PayrollPreliminaryInfo($medspaId: String!) {
    payroll {
      isCurrentUserRegisteredInCheck(medspaId: $medspaId)
      isCompanyRegisteredInCheck(medspaId: $medspaId)
    }
  }
`;

/**
 * __usePayrollPreliminaryInfoQuery__
 *
 * To run a query within a React component, call `usePayrollPreliminaryInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `usePayrollPreliminaryInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePayrollPreliminaryInfoQuery({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function usePayrollPreliminaryInfoQuery(
  baseOptions: Apollo.QueryHookOptions<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  > &
    (
      | { variables: PayrollPreliminaryInfoQueryVariables; skip?: boolean }
      | { skip: boolean }
    )
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >(PayrollPreliminaryInfoDocument, options);
}
export function usePayrollPreliminaryInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >(PayrollPreliminaryInfoDocument, options);
}
export function usePayrollPreliminaryInfoSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        PayrollPreliminaryInfoQuery,
        PayrollPreliminaryInfoQueryVariables
      >
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    PayrollPreliminaryInfoQuery,
    PayrollPreliminaryInfoQueryVariables
  >(PayrollPreliminaryInfoDocument, options);
}
export type PayrollPreliminaryInfoQueryHookResult = ReturnType<
  typeof usePayrollPreliminaryInfoQuery
>;
export type PayrollPreliminaryInfoLazyQueryHookResult = ReturnType<
  typeof usePayrollPreliminaryInfoLazyQuery
>;
export type PayrollPreliminaryInfoSuspenseQueryHookResult = ReturnType<
  typeof usePayrollPreliminaryInfoSuspenseQuery
>;
export type PayrollPreliminaryInfoQueryResult = Apollo.QueryResult<
  PayrollPreliminaryInfoQuery,
  PayrollPreliminaryInfoQueryVariables
>;
export const MarkBusinessDetailsCompletedDocument = gql`
  mutation MarkBusinessDetailsCompleted($medspaId: String!) {
    payroll {
      markBusinessDetailsCompleted(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type MarkBusinessDetailsCompletedMutationFn = Apollo.MutationFunction<
  MarkBusinessDetailsCompletedMutation,
  MarkBusinessDetailsCompletedMutationVariables
>;

/**
 * __useMarkBusinessDetailsCompletedMutation__
 *
 * To run a mutation, you first call `useMarkBusinessDetailsCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkBusinessDetailsCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markBusinessDetailsCompletedMutation, { data, loading, error }] = useMarkBusinessDetailsCompletedMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useMarkBusinessDetailsCompletedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkBusinessDetailsCompletedMutation,
    MarkBusinessDetailsCompletedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkBusinessDetailsCompletedMutation,
    MarkBusinessDetailsCompletedMutationVariables
  >(MarkBusinessDetailsCompletedDocument, options);
}
export type MarkBusinessDetailsCompletedMutationHookResult = ReturnType<
  typeof useMarkBusinessDetailsCompletedMutation
>;
export type MarkBusinessDetailsCompletedMutationResult =
  Apollo.MutationResult<MarkBusinessDetailsCompletedMutation>;
export type MarkBusinessDetailsCompletedMutationOptions =
  Apollo.BaseMutationOptions<
    MarkBusinessDetailsCompletedMutation,
    MarkBusinessDetailsCompletedMutationVariables
  >;
export const MarkPayHistoryCompletedDocument = gql`
  mutation MarkPayHistoryCompleted($medspaId: String!) {
    payroll {
      markPayHistoryCompleted(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type MarkPayHistoryCompletedMutationFn = Apollo.MutationFunction<
  MarkPayHistoryCompletedMutation,
  MarkPayHistoryCompletedMutationVariables
>;

/**
 * __useMarkPayHistoryCompletedMutation__
 *
 * To run a mutation, you first call `useMarkPayHistoryCompletedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkPayHistoryCompletedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markPayHistoryCompletedMutation, { data, loading, error }] = useMarkPayHistoryCompletedMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useMarkPayHistoryCompletedMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MarkPayHistoryCompletedMutation,
    MarkPayHistoryCompletedMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    MarkPayHistoryCompletedMutation,
    MarkPayHistoryCompletedMutationVariables
  >(MarkPayHistoryCompletedDocument, options);
}
export type MarkPayHistoryCompletedMutationHookResult = ReturnType<
  typeof useMarkPayHistoryCompletedMutation
>;
export type MarkPayHistoryCompletedMutationResult =
  Apollo.MutationResult<MarkPayHistoryCompletedMutation>;
export type MarkPayHistoryCompletedMutationOptions = Apollo.BaseMutationOptions<
  MarkPayHistoryCompletedMutation,
  MarkPayHistoryCompletedMutationVariables
>;
export const SendOnboardRemindersToWorkersDocument = gql`
  mutation SendOnboardRemindersToWorkers($medspaId: String!) {
    payroll {
      sendOnboardRemindersToWorkers(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type SendOnboardRemindersToWorkersMutationFn = Apollo.MutationFunction<
  SendOnboardRemindersToWorkersMutation,
  SendOnboardRemindersToWorkersMutationVariables
>;

/**
 * __useSendOnboardRemindersToWorkersMutation__
 *
 * To run a mutation, you first call `useSendOnboardRemindersToWorkersMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendOnboardRemindersToWorkersMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendOnboardRemindersToWorkersMutation, { data, loading, error }] = useSendOnboardRemindersToWorkersMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useSendOnboardRemindersToWorkersMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendOnboardRemindersToWorkersMutation,
    SendOnboardRemindersToWorkersMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SendOnboardRemindersToWorkersMutation,
    SendOnboardRemindersToWorkersMutationVariables
  >(SendOnboardRemindersToWorkersDocument, options);
}
export type SendOnboardRemindersToWorkersMutationHookResult = ReturnType<
  typeof useSendOnboardRemindersToWorkersMutation
>;
export type SendOnboardRemindersToWorkersMutationResult =
  Apollo.MutationResult<SendOnboardRemindersToWorkersMutation>;
export type SendOnboardRemindersToWorkersMutationOptions =
  Apollo.BaseMutationOptions<
    SendOnboardRemindersToWorkersMutation,
    SendOnboardRemindersToWorkersMutationVariables
  >;
export const StartImplementationDocument = gql`
  mutation StartImplementation($medspaId: String!) {
    payroll {
      startImplementation(medspaId: $medspaId) {
        ok
        message
      }
    }
  }
`;
export type StartImplementationMutationFn = Apollo.MutationFunction<
  StartImplementationMutation,
  StartImplementationMutationVariables
>;

/**
 * __useStartImplementationMutation__
 *
 * To run a mutation, you first call `useStartImplementationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useStartImplementationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [startImplementationMutation, { data, loading, error }] = useStartImplementationMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *   },
 * });
 */
export function useStartImplementationMutation(
  baseOptions?: Apollo.MutationHookOptions<
    StartImplementationMutation,
    StartImplementationMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    StartImplementationMutation,
    StartImplementationMutationVariables
  >(StartImplementationDocument, options);
}
export type StartImplementationMutationHookResult = ReturnType<
  typeof useStartImplementationMutation
>;
export type StartImplementationMutationResult =
  Apollo.MutationResult<StartImplementationMutation>;
export type StartImplementationMutationOptions = Apollo.BaseMutationOptions<
  StartImplementationMutation,
  StartImplementationMutationVariables
>;
export const CreateOrUpdateSignatoryDocument = gql`
  mutation CreateOrUpdateSignatory($medspaId: String!, $title: String!) {
    payroll {
      createOrUpdateSignatory(medspaId: $medspaId, title: $title) {
        ok
        message
      }
    }
  }
`;
export type CreateOrUpdateSignatoryMutationFn = Apollo.MutationFunction<
  CreateOrUpdateSignatoryMutation,
  CreateOrUpdateSignatoryMutationVariables
>;

/**
 * __useCreateOrUpdateSignatoryMutation__
 *
 * To run a mutation, you first call `useCreateOrUpdateSignatoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateOrUpdateSignatoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createOrUpdateSignatoryMutation, { data, loading, error }] = useCreateOrUpdateSignatoryMutation({
 *   variables: {
 *      medspaId: // value for 'medspaId'
 *      title: // value for 'title'
 *   },
 * });
 */
export function useCreateOrUpdateSignatoryMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateOrUpdateSignatoryMutation,
    CreateOrUpdateSignatoryMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    CreateOrUpdateSignatoryMutation,
    CreateOrUpdateSignatoryMutationVariables
  >(CreateOrUpdateSignatoryDocument, options);
}
export type CreateOrUpdateSignatoryMutationHookResult = ReturnType<
  typeof useCreateOrUpdateSignatoryMutation
>;
export type CreateOrUpdateSignatoryMutationResult =
  Apollo.MutationResult<CreateOrUpdateSignatoryMutation>;
export type CreateOrUpdateSignatoryMutationOptions = Apollo.BaseMutationOptions<
  CreateOrUpdateSignatoryMutation,
  CreateOrUpdateSignatoryMutationVariables
>;
